import React from 'react'
import { openURL } from 'renderer/viewer/lib/simpleUtils'
import styles from './utopiaLanding.module.css'

export function renderUtopiaModalParagraph (text: string) {
  const parts = text.split(/(https?:\/\/[^\s]+)/g)
  return parts.map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      return (
        <button
          key={i}
          type="button"
          className={styles.joinLink}
          onClick={() => openURL(part, true)}
        >
          {part}
        </button>
      )
    }
    if (part.includes('@') && part.includes('.') && !part.includes(' ')) {
      return <a key={i} href={`mailto:${part}`} className={styles.joinLink}>{part}</a>
    }
    return <React.Fragment key={i}>{part}</React.Fragment>
  })
}
